var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20001 2.70001V4.50001H4.50001V13.5H13.5V10.8H15.3V14.4C15.3 14.8971 14.8971 15.3 14.4 15.3H3.60001C3.10296 15.3 2.70001 14.8971 2.70001 14.4V3.60001C2.70001 3.10296 3.10296 2.70001 3.60001 2.70001H7.20001ZM15.3 2.70001V8.10001H13.5L13.4999 5.77261L9.63641 9.63641L8.36362 8.36362L12.2264 4.50001H9.90001V2.70001H15.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.887d0010.svg";
export { ForwardRef as ReactComponent };